import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "../../resources/scss/header_component.scss";
import IRSLogo from "../../resources/image/irs-logo.png";
import { KEYCLOAK_ROLES } from "../../constant";
import mapAuthorization from "../../utils/mapAuthorization";

const MENU = [
  {
    key: "KYC_UPLOAD_STATUS",
    title: "KYC Upload Status",
    url: "/kyc-upload-status",
    authorizeGroups: [
      "/services/irs/irs-administrator",
      "/services/irs/irs-operator",
      "/services/irs/irs-system-operation",
      "/services/irs/irs-regulator",
    ],
    authorizedRoles: [],
  },
  {
    key: "IRS_TIER_PRICING",
    title: "IRS Tier Pricing",
    url: "/tier-pricing",
    authorizeGroups: [
      "/services/irs/irs-administrator",
      "/services/irs/irs-operator",
      "/services/irs/irs-system-operation",
      "/services/irs/irs-regulator",
    ],
    authorizedRoles: [],
  },
  {
    key: "HISTORY_LOG",
    title: "Tier History Log",
    url: "/tier-pricing-history",
    authorizeGroups: [
      "/services/irs/irs-administrator",
      "/services/irs/irs-operator",
      "/services/irs/irs-system-operation",
      "/services/irs/irs-regulator",
    ],
    authorizedRoles: [],
  },
  {
    key: "EXCHANGE RATE",
    title: "Exchange Rate",
    authorizeGroups: ["/services/irs/irs-administrator"],
    authorizedRoles: [
      KEYCLOAK_ROLES.VIEW_EXCHANGE_RATE_CONF,
      KEYCLOAK_ROLES.VIEW_BANK_COST_RATE_CONF,
    ],
    children: [
      {
        key: "CUSTOMER RATE",
        title: "Customer Rate",
        url: "/exchange-rate",
        authorizeGroups: ["/services/irs/irs-administrator"],
        authorizedRoles: [KEYCLOAK_ROLES.VIEW_EXCHANGE_RATE_CONF],
      },
      {
        key: "SPECIAL CUSTOMER",
        title: "Special Customer",
        url: "/special-customer",
        authorizeGroups: ["/services/irs/irs-administrator"],
        authorizedRoles: [],
      },
      {
        key: "BANK COST RATE",
        title: "Bank Cost Rate",
        url: "/bank-cost-rate",
        authorizeGroups: [],
        authorizedRoles: [KEYCLOAK_ROLES.VIEW_BANK_COST_RATE_CONF],
      },
    ],
  },
  {
    key: "BOT_REPORT",
    title: "BOT Report",
    authorizeGroups: [
      "/services/irs/irs-administrator",
      "/services/irs/irs-operator",
      "/services/irs/irs-regulator",
      "/services/irs/irs-exchange-rate",
    ],
    authorizedRoles: [],
    children: [
      {
        key: "BOT_REPORT_DOWNLOAD",
        title: "Download BOT Report",
        url: "/bot-report/download",
        authorizeGroups: [
          "/services/irs/irs-administrator",
          "/services/irs/irs-operator",
          "/services/irs/irs-regulator",
          "/services/irs/irs-exchange-rate",
        ],
        authorizedRoles: [],
      },
      {
        key: "BOT_REPORT_UPLOAD",
        title: "Upload BOT Report",
        url: "/bot-report/upload",
        authorizeGroups: [
          "/services/irs/irs-administrator",
          "/services/irs/irs-exchange-rate",
        ],
        authorizedRoles: [],
      },
    ],
  },
  {
    key: "REPORT",
    title: "Reports",
    authorizeGroups: [],
    authorizedRoles: [
      KEYCLOAK_ROLES.VIEW_IRS_TRANSACTION_RPT,
      KEYCLOAK_ROLES.VIEW_IRS_MYANMAR_TRANSACTION_RPT,
      KEYCLOAK_ROLES.VIEW_IRS_CAMBODIA_TRANSACTION_RPT,
    ],
    children: [
      {
        key: "IRS_REPORT",
        title: "International Remittance Report",
        url: "/report/irs",
        authorizeGroups: [],
        authorizedRoles: [
          KEYCLOAK_ROLES.VIEW_IRS_TRANSACTION_RPT,
          KEYCLOAK_ROLES.VIEW_IRS_MYANMAR_TRANSACTION_RPT,
          KEYCLOAK_ROLES.VIEW_IRS_CAMBODIA_TRANSACTION_RPT,
        ],
      },
    ],
  },
];

class Header extends Component {
  changeLanguage = (lng) => {
    const { i18n } = this.props;
    if (i18n.language === lng) {
      return;
    }
    i18n.changeLanguage(lng);
  };

  renderMenu = (menu) => {
    const { userGroup, userRoles } = this.props;

    if (
      !mapAuthorization(userGroup, menu.authorizeGroups) &&
      !mapAuthorization(userRoles, menu.authorizedRoles)
    )
      return null;
    if (menu.children) {
      return (
        <li key={menu.key} className="dropdown">
          <a href="#top" className="dropdown-toggle" data-toggle="dropdown">
            {menu.title}
            <b className="caret" />
          </a>
          <ul className="dropdown-menu" id="menu">
            {menu.children.map((item) => {
              if (
                !mapAuthorization(userGroup, item.authorizeGroups) &&
                !mapAuthorization(userRoles, item.authorizedRoles)
              )
                return null;
              return (
                <li key={item.key}>
                  <Link to={item.url} className="dropdown-item">
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </li>
      );
    }
    return (
      <li key={menu.key}>
        <Link to={menu.url}>{menu.title}</Link>
      </li>
    );
  };

  render() {
    const { username, logout, t } = this.props;

    return (
      <div className="app_top">
        <div className="container-fluid">
          <div className="header row justify-content-center align-items-center">
            <div className="col-sm-10 ">
              <div className="irs-logo">
                <img
                  src={IRSLogo}
                  alt={t("header.back to home page")}
                  title={t("header.back to home page")}
                />
              </div>
              <div className="menu">
                <div className="menu-account">
                  <ul>
                    <li className="first">
                      {t("common.welcome")} <b>{username}</b>
                    </li>
                    <li>
                      <button onClick={logout}>
                        <span style={{ color: "red" }}>
                          {t("common.log out")}
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>

                <div className="menu-main">
                  {MENU.map((item) => this.renderMenu(item))}
                  <li className="first">
                    {t("header.call center 1240, press 4")}
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Header);
